module.exports = __webpack_public_path__ + "static/media/mpt.087abbd8.svg";